export const canIUseApi = (api) => api in window;
